import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
} from '@angular/core';
import { openClose } from '@core/animations/animations';
import { ICON } from '@core/util/icon';
import { ContactInfo } from '@models/lender';
import { Select } from '@ngxs/store';
import { ClipboardService } from '@services/clipboard/clipboard.service';
import { DefaultEmailSubjectSelectors } from '@state/global/default-email';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-contact-details-card',
	templateUrl: './contact-details.component.html',
	animations: [openClose()],
	standalone: false,
})
export class ContactDetailsComponent implements OnInit, OnChanges {
	@Select(DefaultEmailSubjectSelectors.defaultEmailSubject)
	public emailSubject$: Observable<string>;

	@Input() contactDetails: ContactInfo;
	@Input() contactType: 'lender' | 'branch' = 'lender';
	@Input() isEditable = true;
	@Output() edit: EventEmitter<void> = new EventEmitter();

	constructor(private clipboard: ClipboardService) {}

	public ICON = ICON;
	public showEmptyState = false;

	ngOnInit(): void {
		this.showEmptyState = this.checkIfEmpty();
	}

	ngOnChanges(): void {
		this.showEmptyState = this.checkIfEmpty();
	}

	checkIfEmpty(): boolean {
		if (!this.contactDetails) {
			return true;
		}

		return Object.values(this.contactDetails).every((value) => !value);
	}

	editContactDetails(): void {
		this.edit.emit();
	}

	copyToClipboard(text: string) {
		this.clipboard.copyText(text, true);
	}
}
